<template>
  <div class="main-wrap">
    <!-- 金额总览区域 start -->
    <div class="header-info">
      <div class="title-primary">
        <div class="table">总销售金额</div>
        <div class="money">￥{{ supplierAll.total }}</div>
      </div>
      <van-row class="title-secondary" type="flex" justify="space-between">
        <div>
          <div class="money">￥{{ supplierAll.thismounthsubsist }}</div>
          <div class="table">本月应收款总额</div>
          <br />
          <div class="money">￥{{ supplierAll.thismonthamout }}</div>
          <div class="table">本月销售总额</div>
        </div>
        <div>
          <div class="money">￥{{ supplierAll.totalsubsist }}</div>
          <div class="table">总应收账款</div>
          <br />
          <div class="money">￥{{ supplierAll.todayamout }}</div>
          <div class="table">今日销售总额</div>
        </div>
      </van-row>

      <van-row class="echart-wrpa">
        <van-row class="echart-container" :style="{ height: showEchart ? '420px' : '0' }">
          <div class="echart" id="echart01" ref="echart01"></div>
          <div class="echart" id="echart02" ref="echart02"></div>
        </van-row>
        <van-row class="fold" type="flex" justify="center" @click="showEchart = !showEchart">
          <van-icon :class="showEchart ? 'active' : ''" name="arrow-down" />
        </van-row>
      </van-row>
    </div>
    <!-- 金额总览区域 end -->

    <!-- 搜索区域 start -->
    <van-sticky class="middle-search">
      <van-search
        v-model="keyword"
        shape="round"
        background="#f6f4f2"
        placeholder="请输入客户名称"
        @search="onSearch"
      />
    </van-sticky>
    <!-- 搜索区域 end -->

    <!-- 列表区域 start -->
    <div class="footer-list">
      <van-list
        class="container list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        finished-text="没有更多了"
        error-text="点击重新加载"
        @load="onLoad"
      >
        <van-row
          class="list-item"
          v-for="(item, index) in dataList"
          :key="index"
          type="flex"
          justify="space-between"
          align="center"
          @click="goToInfo(item.id, item.name)"
        >
          <van-row class="left">
            <div class="abbreviation">{{ item.abbreviation }}</div>
            <div class="fullName">{{ item.name }}</div>
          </van-row>
          <van-row class="right" type="flex">
            <div class="value">{{ item.currencyamount }}</div>
            <van-icon name="arrow" />
          </van-row>
        </van-row>
      </van-list>
    </div>
    <!-- 列表区域 end -->
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      keyword: "",
      loading: false,
      finished: false,
      error: false,
      showEchart: false,
      page: 1,
      supplierAll: {},
      dataList: [],
    };
  },
  methods: {
    /**
     * 初始化采购金额信息
     */
    async initMoneyInfo() {
      // 在这发起请求
      let { data } = await this.$post(this.$api.stGetCustomerAll);
      console.log(data);
      this.supplierAll = data;
      this.echartInit();
    },
    /**
     * 渲染echart
     */
    echartInit() {
      this.$nextTick(() => {
        const list1 = this.supplierAll.month.lists;
        const list2 = this.supplierAll.year.lists;
        const echart01 = echarts.init(this.$refs.echart01);
        const echart02 = echarts.init(this.$refs.echart02);

        console.log(list1);
        console.log(list2);

        echart01.setOption({
          title: {
            text: this.supplierAll.month.text,
            left: "center",
            bottom: "0px",
            textStyle: {
              color: "#505050",
              fontSize: "14px",
            },
          },
          tooltip: { trigger: "axis" },
          color: ["#2a82e4"],
          grid: {
            left: "20px",
            right: "20px",
            top: "10px",
            bottom: "45px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list1.dates,
          },
          yAxis: [
            {
              name: "销售金额",
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "销售金额(CNY)",
              type: "bar",
              data: list1.price,
              yAxisIndex: 0,
              smooth: true,
            },
          ],
        });

        echart02.setOption({
          title: {
            text: this.supplierAll.year.text,
            left: "center",
            bottom: "0px",
            textStyle: {
              color: "#505050",
              fontSize: "14px",
            },
          },
          tooltip: { trigger: "axis" },
          color: ["#2a82e4"],
          grid: {
            left: "20px",
            right: "20px",
            top: "10px",
            bottom: "45px",
            containcolor_3: true,
          },
          // toolbox: { feature: { saveAsImage: {} } },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list2.dates,
          },
          yAxis: [
            {
              name: "销售金额",
              type: "value",
              axisLabel: {
                formatter: function() {
                  return "";
                },
              },
            },
          ],
          series: [
            {
              name: "销售金额(CNY)",
              type: "line",
              data: list2.price,
              yAxisIndex: 0,
              smooth: true,
            },
          ],
        });
      });
    },

    /**
     * 点击键盘上的搜索/回车按钮后触发
     */
    onSearch() {
      console.log("onSearch");
      // this.loading = true;
      this.page = 1;
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      this.onLoad();
    },
    /**
     * 列表触底时触发
     */
    async onLoad() {
      // console.log("onLoad");
      // 请求列表数据
      let params = {
        page: this.page,
        name: this.keyword,
      };
      try {
        let { data } = await this.$post(this.$api.stGetCustomerList, params);
        console.log(data);
        // 若数据已全部加载完毕
        if (data.length == 0) {
          this.finished = true;
        }
        if (this.page == 1) {
          this.dataList = [];
        }
        this.dataList.push(...data);
        this.page++;
      } catch (error) {
        console.log(error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * 跳转到供应商详情
     */
    goToInfo(id, name) {
      this.$router.push(`/dataReport/customer/info/${id}`);
    },
  },
  mounted() {
    this.initMoneyInfo();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "客户统计" });
    });
  },
};
</script>

<style lang="scss" scoped>
$green: #ff8d1a;
$green: #00e0d1;
$gary: #a6a6a6;
.main-wrap {
  min-height: 100%;
  background-color: #fff;
  .header-info {
    box-sizing: border-box;
    padding: 16px 16px 0;
    font-size: 12px;
    color: #fff;
    background-color: #51596e;

    .title-primary {
      color: #fff;

      .money {
        text-align: center;
        font-family: "MicrosoftJhengHei";
        font-size: 30px;
        font-weight: 500;
      }
    }

    .title-secondary {
      margin-top: 30px;
      text-align: center;
      font-size: 12px;

      .money {
        margin-bottom: 6px;
        color: $green;
      }
    }

    .echart-wrpa {
      margin-top: 20px;
      background-color: #51596e;

      .echart-container {
        overflow: hidden;
        transition: height 0.8s;
        .echart {
          margin-bottom: 20px;
          height: 200px;
          background-color: #fff;
        }
      }

      .fold {
        padding: 8px 0;
        z-index: 1;
        background-color: #51596e;
      }
      .fold .van-icon {
        font-size: 26px;
        transition: transform 0.8s;
      }
      .fold .van-icon.active {
        transform: rotate(-180deg);
      }
    }
  }

  .middle-search {
    ::v-deep .van-search__content {
      background-color: #fff;
    }
  }

  .footer-list {
    .container {
      padding: 16px;
      .list-item {
        padding-top: 4px;
        padding-bottom: 8px;
        border-bottom: 1px solid #e5e5e5;

        .left {
          .abbreviation {
            color: #505050;
            font-size: 14px;
          }
          .fullName {
            color: #a6a6a6;
            font-size: 12px;
          }
        }

        .right {
          .value {
            font-size: 12px;
            color: $green;
          }
          .van-icon {
            margin-left: 8px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
